import { render } from "./CategoriesMenu.vue?vue&type=template&id=f78ed146"
const script = {}

import "./CategoriesMenu.vue?vue&type=style&index=0&id=f78ed146&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__